import * as actions from 'actions/types';

export const lastWizardStep = 7;
export const saveWizardStep = 9;

//===== Wizard (stepper) form actions
export function initWizard() {
  return {
    type: actions.INIT_WIZARD,
    payload: {
      step: 1,
      progressStep: 1,
      isSaved: false,
      isSubmitted: false
    }
  };
}

// when user click a step link to move between submitted steps
export function changeWizardStep(step) {
  return {
    type: actions.CHANGE_WIZARD_STEP,
    payload: { step }
  };
}

// when user click `continue` at wizard form
export function submitWizardStep(wizard) {
  const step = wizard.step + 1;
  const wProgressStep = wizard.progressStep;
  const progressStep =
    wizard.step === wProgressStep ? wProgressStep + 1 : wProgressStep;

  const updatedWizard = { step, progressStep };

  return {
    type: actions.SUBMIT_WIZARD_STEP,
    payload: updatedWizard
  };
}

// when wizard form is submitted
export function submitWizard() {
  const updatedWizard = { step: lastWizardStep, isSubmitted: true };

  return {
    type: actions.SUBMIT_WIZARD,
    payload: updatedWizard
  };
}

// when wizard form is saved
export function saveWizard() {
  const updatedWizard = { step: saveWizardStep, isSaved: true };

  return {
    type: actions.SAVE_WIZARD,
    payload: updatedWizard
  };
}

export function clearWizard() {
  return { type: actions.CLEAR_WIZARD };
}



// WEBPACK FOOTER //
// ./src/actions/wizard.js